export default __webpack_public_path__ + "static/media/Slide27.a10f1907.jpg";